import { Outlet } from 'react-router-dom';

import { ReportScopeProvider } from 'src/routes/context/ReportScopeContext';

/**
 * Raporlar bölümünün ortak yerleşimi: TEK bir ReportScopeProvider sağlar; böylece
 * hub'da seçilen kapsam (Firma→Şube→Çalışan) tüm rapor alt sayfalarına taşınır.
 */
export function ReportsLayout() {
  return (
    <ReportScopeProvider>
      <Outlet />
    </ReportScopeProvider>
  );
}
